<template>
    <div>
        <header>
            <p>主体信息变更列表</p>
        </header>
        <div class="container">
            <div class="header-search">
                  <p>
                      <span>变更时间 : </span>
                      <el-date-picker
                              size="small"
                              style="width: 290px"
                              v-model="time"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              type="daterange"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
                      </el-date-picker>
                  </p>
                  <p style="margin-left: 20px">
                      <span>变更模块 : </span>
                      <el-select v-model="changePart" placeholder="请选择" size="small" style="width: 290px;" clearable>
                          <el-option v-if="this.id" label="主体基本信息" value="baseInfo"></el-option>
                          <el-option v-if="this.id" label="主体资质信息" value="qualificationCert"></el-option>
                          <el-option v-if="this.id" label="主体业绩" value="performance"></el-option>
                          <el-option v-if="this.id" label="主体财税/社保信息" value="financeSocialSecurity"></el-option>
                          <el-option v-if="this.id" label="主体人员信息" value="person"></el-option>
                          <el-option v-if="this.id" label="主体奖惩信息" value="rewardPunishment"></el-option>
                          <el-option v-if="this.id" label="中介服务事项" value="serviceItems"></el-option>
                          <el-option v-if="this.id" label="主体其他信息" value="otherInfo"></el-option>
                          <el-option v-if="isAdmin == true || !this.id" label="自然人基本信息" value="naturalPerson"></el-option>
                      </el-select>
                  </p>
                  <p style="margin-left: 20px">
                      <el-button size="small" @click="searchEvent()">搜索</el-button>
                      <el-button size="small" @click="searchEvent()">刷新</el-button>
                      <el-button size="small">返回</el-button>
                  </p>
            </div>
            <div class="card-item">
                <div class="card-content">
                    <el-table
                            border
                            :data="tableList"
                            :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',
                        }">
                        <el-table-column
                                fixed
                                prop="date"
                                type="index"
                                label="序号"
                                align="center"
                                width="60px">
                            <template scope="scope">
                                <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                width="100"
                                align="center">
                            <template scope="scope">
                                <el-button type="text" @click="goChangeMod(scope.row)">查看</el-button>
                                <el-button v-if="scope.row.status == -1" type="text" @click="deleteData(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                label="状态"
                                width="120"
                                align="center">
                            <template scope="scope">
                                <p v-if="scope.row.status == -1" class="change-examine"><i class="examine-no-adopt"></i><span>待提交</span></p>
                                <p v-else-if="scope.row.status == 1" class="change-examine"><i class="examine-adopt"></i><span>已通过</span></p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="entType"
                                label="主体类型"
                                width="100"
                                align="center">
                            <template scope="scope">
                                <p v-if="scope.row.entType == 1">自然人</p>
                                <p v-if="scope.row.entType == 2">法人</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="uniqueCode"
                                label="主体代码"
                                width="202"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="entName"
                                align="center"
                                width="202"
                                label="主体名称">
                        </el-table-column>
                        <el-table-column
                                prop="modules"
                                align="center"
                                width="200"
                                label="变更模块">
                        </el-table-column>
                        <el-table-column
                                prop="createUser"
                                label="提交人"
                                width="130"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="createTime"
                                align="center"
                                width="174"
                                label="提交时间">
                        </el-table-column>
                        <el-table-column
                                prop="updateUser"
                                label="修改人"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                prop="updateTime"
                                label="修改时间"
                                width="174"
                                align="center">
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="total, prev, pager, next"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from "vuex";
    export default {
        data(){
            return {
                newId:'',
                time: null,
                changePart: null,
                tableList:[],
                currentPage:1,
                pageSize:10,
                total:0,
                isAdmin: false
            }
        },
        computed:{
            ...mapState({
                id:(state) => state.user.orgId,
                entId:(state) => state.user.userinfo.userId
            })
        },
        created() {
            this.querData();
            this.getSysIsAdmin();
        },
        activated() {
            this.querData();
        },
        methods: {
            // 获取当前用户是否为超级管理员
            getSysIsAdmin(){
                this.$http.post('/sys/isAdmin').then(res=>{
                    if(res.data && res.data.code ==1){
                        this.isAdmin = res.data.data.isSupperAdmin;
                    }
                })
            },
            // 获取数据
            querData() {
                if(this.id){
                    this.newId =this.id
                }else{
                    this.newId =this.entId
                }
                this.$http.post('/change/record/list', {
                    page: this.currentPage,
                    rows: this.pageSize,
                    filter: {
                      personId:this.newId,
                      startTime:this.time && this.time[0],
                      endTime:this.time && this.time[1],
                    },
                    searchKey: this.changePart,
                    orderBy: 'create_time desc'
                }).then((res) => {
                    if(res.data){
                        this.tableList = res.data.rows;
                        this.tableList.forEach((item,index)=>{
                            item.createTime = item.createTime ? item.createTime.replace(/-/g,'/') : '';
                            item.updateTime = item.createTime ? item.updateTime.replace(/-/g,'/') : '';
                        })
                        this.total = res.data.total;
                    }
                })
            },
            // 跳转
            goChangeMod(row) {
                if(row.entType == 2){
                    // 法人变更页
                    if(row.status == -1){
                        // 未提交
                        this.$router.push({path:`/mainDealManagementChange/index/${row.entId}/${row.id}`})
                    }else{
                        // 已通过
                        this.$router.push({path:`/mainDealManagementChangeDetail/index/${row.entId}/${row.id}`})
                    }
                }else if(row.entType == 1){
                    // 自然人变更页
                    if(row.status == -1){
                        // 未提交
                        this.$router.push({path:'/naturalBasicInformationChange/natural-basicInfo-form',query:{changeId:row.entId}})
                    }else if(row.status == 1){
                        // 已通过
                        this.$router.push({path:'/naturalBasicInformationChangeDetail/natural-basicInfo-view',query:{changeId:row.entId,changeRecordId:row.id}})
                    }
                }
            },
            // 删除数据
            deleteData(row) {
                this.$http.delete('/change/record/'+row.id).then((res)=>{
                    if(res.data.code ==1){
                        this.$notify({
                            title: '删除数据',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'success'
                        })
                        this.querData();
                    }else{
                        this.$notify({
                            title: '删除数据',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'warning'
                        })
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.querData();
            },
            searchEvent(){
                this.currentPage = 1;
                this.querData();
            },
        }
    }
</script>
<style lang="scss" scoped>
    header{
        height: 68px;
        background: #fff;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        p{
            font-size: 18px;
            font-weight: bold;
            color: #000000;
            margin-left: 32px;
        }
    }
    .container{
        margin: 20px;
        .header-search{
            width: 100%;
            height: 80px;
            background: #fff;
            margin-bottom: 20px;
            line-height: 80px;
            padding: 0 20px;
            display: flex;
           /deep/ .el-input--suffix{
                height: 55px;
            }
        }
        .change-examine{
            display: flex;
            align-items: center;
            justify-content: center;
            i{
                width: 6px;
                height: 6px;
                border-radius: 50%;
                margin: 0 8px;
            }
            i.examine-adopt{
                background: #52C41A;
            }
            i.examine-no-adopt{
                background: #FA6400;
            }
            span{
                width: 60px;
                text-align: left;
            }
        }
    }
</style>